import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper'

export default class DateTimeColumnFactory extends ColumnFactory {

    public static isPlainText = true;
    public static isJQueryElement = false;

    constructor(private params: any) {
        super(params);
    }

    public getValue(): any {
        if (!this.raw) {
            return '';
        }

        let date = DateHelper.parseDotNetDateTimeString(this.raw);

        let showDate: boolean, showTime: boolean;
        if (this.params.format === 'Date') {
            showDate = true;
            showTime = false;
        }
        else if (this.params.format === 'Time') {
            showDate = false;
            showTime = true;
        }
        else if (this.params.format === 'DateTime') {
            showDate = true;
            showTime = true;
        }
        else {
            // Standardformat
            showDate = null;
            showTime = null;
        }

        return DateHelper.toString(date, showTime, showDate);
    }
}

ComponentManager.setFactory('DateTimeColumn', DateTimeColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');